import { useRef, useState, useEffect } from "react";
import Select from "react-select";
import Slider from "rc-slider";
import { useDispatch } from 'react-redux';
import { DeleteKeys, updateThemeSetting } from "../../../../../actions/appsMoreAction";
import { SOCKET_CONNECTION, TOAST_DISMISS, TOAST_ERROR, TOAST_SUCCESS } from "../../../../../utils";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import DateTimeField from '@1stquad/react-bootstrap-datetimepicker';
import '@1stquad/react-bootstrap-datetimepicker/css/bootstrap-datetimepicker.css';
import { GET_CUSTOM_CSS_STATUS, GET_WIDGET_WALL_DATA } from "../../../../../reducers/keys";
import moment from 'moment';
import $ from 'jquery';
import { closePricingModal } from "../../../../../utils/close_modal";
import { refreshThemes } from "../../../../../actions/firstRunAction";
import { getWidgetWallData } from "../../../../../actions/wallDataAction";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";

const ThemeSetting = (props) => {

  const dispatch = useDispatch()
  const { getThemeSetting, themeSetting, cardStyle, wallData, themecardStyle, themeSettingStatus, activeSetting } = props;
  const { themeId, mobileColumn, blurBackground, blurColor, slideDuration, trimcontent, numberOfCoumn, postFeatured, multiRow, autoPlay } = cardStyle;

  const { autoUpdate, cssStatus, duplicatePostId, randomizePost, playFullVideo, animateBackground, hideUrls, postText, retweetexclude, textDecorate, publicAccess, columnCount, transitionStatus, numberOfPosts, scrollDelay, showHideOlderPost, padding, timeForPopup, slideDelay, popupSlideSpostTexthow, autoScrollStatus, loadMoreStatus, fitRow, slidePost, customUrl, minimumPostWidth, transition, showHideOldPost, carouselPopupAutoPlay } = getThemeSetting;

  const personalization = wallData.wall.Personalization;
  const settingData = props.getThemeSetting;

  const widgetTheme = settingData.signageTheme
  const [transparentBg, setTransparentBg] = useState(0)
  const [shufflePost, setShufflePost] = useState(false)

  const bgColorSelect = [
    { label: "Default Color", value: 0 },
    { label: "Choose Color", value: 1 },
  ];

  const columnSelect = [
    { label: "3 Columns", value: 3 },
    { label: "4 Columns", value: 4 },
    { label: "5 Columns", value: 5 },
    { label: "6 Columns", value: 6 },
  ];

  const carouselColumnSelect = [
    { label: "3 Columns", value: 3 },
    { label: "4 Columns", value: 4 },
    { label: "5 Columns", value: 5 },
    { label: "6 Columns", value: 6 },
  ];

  const columnSelectFocus = [
    { label: "5 Column", value: 5 },
    { label: "7 Column", value: 7 },
    // { label: "10 Columns", value: 10 },
    // { label: "13 Columns", value: 13 },
    // { label: "17 Columns", value: 17 },
  ];


  const rowSelect = [
    { label: "1 Row", value: 1 },
    { label: "2 Row", value: 2 },
  ];

  // trimcontent: 1 = theme's default trim, 2-5 = number of lines to trim post text to
  const trimLineSelect = [
    { label: "Default", value: 0 },
    { label: "Two", value: 2 },
    { label: "Three", value: 3 },
    { label: "Four", value: 4 },
    { label: "Five", value: 5 },
  ];


  const aiRecommendedOption = [
    { label: "Most Recent", value: 0 },
    { label: "Shuffle", value: 1 },
    { label: "AI Recommended", value: 2 },
    { label: "Oldest To Newest", value: 3 },
    { label: "Newest To Oldest", value: 4 },
  ];


  const scrollSpeed = [
    { label: "Slower", value: 80 },
    { label: "Slow", value: 70 },
    { label: "Normal", value: 50 },
    { label: "Fast", value: 30 },
    { label: "Faster", value: 20 },
  ];


  const onClickSelect = [
    { label: "Do Nothing", value: 0 },
    { label: "Open pop-up", value: 1 },
    { label: "Go to source", value: 2 },
    { label: "Custom Url", value: 3 },
  ];

  const [customUrlerror, setCustomUrlerror] = useState(false)
  const [totalPost, setTotalPost] = useState(numberOfPosts)
  const [hideOld, setHideOld] = useState(showHideOlderPost == 0 ? 0 : 1)
  const [postWidth, setPostWidth] = useState(minimumPostWidth)
  const [bgColor, setBgColor] = useState(transition ? transition : '#ffffff')
  const [date, setDate] = useState(showHideOldPost)
  const [postDate, setpostDate] = useState(moment.unix(showHideOldPost).utc().format('MM/DD/YYYY HH:mm'))
  const [blur, setBlur] = useState(blurColor ? blurColor : '#000000');
  const [spinner, setspinner] = useState(false);

  const [moblieColumnSelect, setMoblieColumnSelect] = useState([
    { label: "32 (8X4) ", value: 32 },
    { label: "18 (6X3) ", value: 18 },
    { label: "12 (4X3) ", value: 12 },
    { label: "8 (4X2) ", value: 8 },
  ]);

  const [customSlelect, setCustomSlelect] = useState([
    { label: "One Day Ago", value: 1 },
    { label: "Two Days Ago", value: 2 },
    { label: "Three Days Ago", value: 3 },
    { label: "Four Days Ago", value: 4 },
    { label: "Five Days Ago", value: 5 },
    { label: "Six Days Ago", value: 6 },
    { label: "Seven Days Ago", value: 7 },
    { label: "One Month", value: 30 },
    { label: "Custom Select", value: 8 },
  ]);


  const myRefname = useRef(null);
  const hideOldPostsLabelRef = useRef(null);
  const [highlightHideOldPosts, setHighlightHideOldPosts] = useState(false);

  const handleChange = e => {
    var myDate = new Date(e);
    var myEpoch = myDate.getTime() / 1000
    setpostDate(moment.unix(myEpoch).utc().format('MM/DD/YYYY HH:mm'))
    themeSetting({ showHideOldPost: myEpoch })
  }

  useEffect(() => {
    setTimeout(() => {
      window.$('#bgColorTransition').minicolors({
        control: 'hue',
        defaultValue: bgColor,
        letterCase: 'lowercase',
        position: 'bottom left',
        change: onBgColorChange,
        theme: 'bootstrap'
      });
      window.$('#blurColor').minicolors({
        control: 'hue',
        defaultValue: blur,
        letterCase: 'lowercase',
        position: 'bottom left',
        change: blurColorChange,
        theme: 'bootstrap'
      });
    }, 1);
  }, [transparentBg])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('tab') === 'changeDateRange' && hideOldPostsLabelRef.current) {
      hideOldPostsLabelRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setHighlightHideOldPosts(true);
      const timeout = setTimeout(() => setHighlightHideOldPosts(false), 1000);
      return () => clearTimeout(timeout);
    }
  }, []);

  const onBgColorChange = (hex, opacity) => {
    if (!hex)
      return;
    if (opacity)
      hex += ', ' + opacity;
    setBgColor(hex)
  }

  const blurColorChange = (hex, opacity) => {
    if (!hex)
      return;
    if (opacity)
      hex += ', ' + opacity;
    setBlur(hex)
  }


  const submitData = () => {

    if (postFeatured == 3 && validateUrl(customUrl) || postFeatured != 3) {
      setspinner(true)

      let obj = {
        wallId: personalization.wallId,
        adminId: localStorage.getItem('Isadmin'),
        ownerId: localStorage.getItem('ownerId'),
        db_table: props.db_table,
        p_id: personalization.id,
        autoUpdate: autoUpdate,
        duplicatePostId: duplicatePostId,
        cssStatus: cssStatus,
        randomizePost: randomizePost,
        loadMoreStatus: loadMoreStatus,
        autoScrollStatus: autoScrollStatus,
        postText: postText,
        postFeatured: postFeatured,
        trimcontent: trimcontent,
        retweetexclude: retweetexclude == true ? 1 : 0,
        popupSlideShow: popupSlideSpostTexthow,
        textDecorate: textDecorate,
        customUrl: `${customUrl}`,
        numberOfPosts: parseInt(numberOfPosts),
        hidePosts: showHideOlderPost == 0 ? 0 : 1,
        showHideOlderPost: showHideOlderPost,
        showHideOldPost: postDate,
        minimumPostWidth: postWidth,
        padding: padding,
        theme_id: personalization.ThemeRule.id,
        transitionStatus: transitionStatus,
        columnCount: columnCount,
        animateBackground: animateBackground,
        transition: bgColor,
        mobileColumn: mobileColumn,
        numberOfCoumn: numberOfCoumn,
        multiRow: multiRow,
        fitRow: fitRow,
        slidePost: slidePost,
        slideDuration: slideDuration,
        playFullVideo: playFullVideo,
        hideUrls: hideUrls,
        publicAccess: publicAccess,
        scrollDelay: scrollDelay ? scrollDelay : 50,
        timeForPopup: timeForPopup,
        transparent: personalization.ThemeRule.transparent,
        trimcontentStatus: trimcontent,
        filterEnableStatus: 0,
        socialAction: personalization.ThemeRule.socialAction,
        popupSlideShowStatus: 1,
        slideDelay: slideDelay,
        blurBackground: blurBackground,
        blurColor: blur,
        autoPlay: autoPlay ? 1 : 0,
        cardStyle: cardStyle,
        carouselPostAutoPlay: carouselPopupAutoPlay ? 1 : 0,
      }


      updateThemeSetting(obj).then(res => {
        const { data } = res
        setspinner(false);
        if (data.status) {
          DeleteKeys();
          TOAST_DISMISS()
          TOAST_SUCCESS(`Theme settings saved successfully.`);
          closePricingModal(dispatch);
          dispatch(refreshThemes());
          dispatch(getWidgetWallData(localStorage.getItem("ownerId"), localStorage.getItem('wallId')))
          wallData['wall']['Personalization']['publicAccess'] = publicAccess;
          wallData['wall']['Personalization']['ThemeRule']['autoPlay'] = autoPlay;
          SOCKET_CONNECTION.emit('wallsuperrefresh', { 'wallId': localStorage.getItem('wallId'), sync: data.synced });
          themeSetting({ cssStatus: cssStatus }, 2)
          dispatch({ type: GET_WIDGET_WALL_DATA, payload: wallData })
          if (shufflePost || obj?.hidePosts || obj?.postText) props.reloadIfreame();
        } else {
          TOAST_DISMISS()
          TOAST_ERROR(data.message);
        }
        props.activeSetting(0);
        removeTab();
      }).catch((error) => console.warn(error))
    } else {
      setCustomUrlerror(true)
    }
  }
  const removeClass = () => {

    $('#uncontrolled-tab-example-tabpane-background').removeClass('active show')
    $('#uncontrolled-tab-example-tab-background').removeClass('active')

  }
  const validateUrl = (value) => {
    return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
  }

  const applyChanges = (status) => {
    const { showDiscardPop } = props;
    if (status == 0) { removeTab(); }
    showDiscardPop(submitData, 'theme-setting', status);
  }

  const removeTab = () => {
    const newUrl = window.location.href.replace(/\?tab=changeDateRange[\/]?/, '')
    window.history.replaceState({}, '', newUrl)
  }

  const maxPostsLimit = ['182789', '182158'].includes(localStorage.getItem('ownerId')) ? 500 : 100;
  return (
    <div className="maintainPopUp noLoader" id="wallThemeSettingsForm" enctype="multipart/form-data" method="post" accept-charset="utf-8">
      <div className="customToolTip overflow-list">
        <div className="pb-3">
          <label className="card-label font-weight-bolder text-dark">Theme Settings</label>
        </div>
        <div className="mb-5">
          <CheckBox label="Auto-Update" id="wallautoUpdate" checked={autoUpdate} onChange={(e) => { themeSetting({ autoUpdate: e.target.checked }); themeSettingStatus(true) }} tooltip="Updates your content automatically according to your update time." />
          <div className="d-flex align-items-center form-group">
            <div className="col-9">
              <label className="control-label me-3 mb-0" htmlFor="wallcssStatus">Custom CSS</label>
              <OverlayTrigger placement="top" overlay={<Tooltip>Add your Custom CSS to personalize the look of your Gallery.</Tooltip>}>
                <span>
                  <FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'text-gray-500 fs-6'} />
                </span>
              </OverlayTrigger>
            </div>
            <div className="col-3">
              <div className="toggleOnBut" onClick={(e) => removeClass()}>
                <span className="switch float-end">
                  <label className="checkbox" htmlFor="wallcssStatus">
                    <input type="checkbox" name="" id="wallcssStatus" className="onoffswitch-checkbox updateStatus" defaultValue={cssStatus}
                      checked={props.planID == 53 ? false : cssStatus}
                      onChange={(e) => {
                        dispatch({ type: GET_CUSTOM_CSS_STATUS, payload: !cssStatus ? e.target.checked : null }); themeSetting({ cssStatus: e.target.checked }, 2);
                        if (e.target.checked) activeSetting(6)
                      }}
                    />
                    <span></span>
                  </label>
                </span>{" "}
              </div>
            </div>

          </div>

          <CheckBox label="Hide Duplicate Post" id="duplicatePost" checked={duplicatePostId} onChange={(e) => { themeSetting({ duplicatePostId: e.target.checked }); themeSettingStatus(true) }} tooltip="This feature helps you hide posts displayed more than once." />

          {![63, 65, 69, 71, 73, 67].includes(themeId) ? <CheckBox label="Hide 'Text Only' Posts" id="postText" checked={postText} onChange={(e) => { themeSetting({ postText: Number(e.target.checked) }); themecardStyle({ postText: Number(e.target.checked) }); themeSettingStatus(true) }} tooltip="Hides posts which are only texts with no media." /> : null}

          {[74, 76, 77].includes(themeId) ? <CheckBox label="Play Full length Video" id="playFullVideo" checked={playFullVideo} onChange={(e) => themeSetting({ playFullVideo: e.target.checked })} tooltip="This option will help you to play complete Video" /> : null}

          {[62, 63, 64, 65, 66, 67, 68, 69, 78].includes(themeId) ? <CheckBox label="Show More Button" id="loadMore" checked={loadMoreStatus} onChange={(e) => themeSetting({ loadMoreStatus: e.target.checked ? 1 : 0, autoScrollStatus: e.target.checked ? 0 : autoScrollStatus })} tooltip="Show/Hide the 'Show more' button" /> : null}

          {[62, 63, 64, 65, 66, 67, 68, 69, 78].includes(themeId) ? <CheckBox label="Auto-Load" id="wallautoScrollStatus" checked={autoScrollStatus} onChange={(e) => { themeSetting({ autoScrollStatus: e.target.checked, loadMoreStatus: e.target.checked ? 0 : loadMoreStatus }) }} tooltip="Experience the never-ending trail of feeds." /> : null}

          {'next-update' && [""].includes(themeId) ? <CheckBox label="Transition Effect" id="transitionEffect" checked={animateBackground} onChange={(e) => themeSetting({ animateBackground: animateBackground ? 0 : 1 })} tooltip="Experience the never-ending trail of feeds." /> : ''}

          {![74, 76, 77].includes(themeId) ? <>
            <CheckBox label="Featured Popup" id="wallmobilePopup" checked={postFeatured} onChange={(e) => themecardStyle({ postFeatured: e.target.checked })} tooltip="Enables pop-up for the posts when clicked." />
            <CheckBox label="Carousel Auto Play" id="carouselPopupAutoPlay" checked={carouselPopupAutoPlay} onChange={(e) => {
              themeSetting({ carouselPopupAutoPlay: e.target.checked })
              themeSettingStatus(true)
            }} tooltip="Auto-slide images and videos in the pop-up carousel. Visible only when Carousel is enabled in Moderation." />
          </> : null}

          {[78].includes(themeId) ?
            <CheckBox label="Hide Urls" id="hideurl" checked={hideUrls} onChange={(e) => { themeSetting({ hideUrls: e.target.checked }); themeSettingStatus(true); }} tooltip="Removes URL links from the contect" />
            : null}

          <CheckBox label="Exclude Retweets" id="wallretweetexclude" checked={retweetexclude} onChange={(e) => { themeSetting({ retweetexclude: e.target.checked }); themeSettingStatus(true) }} tooltip="Prevents duplicacy of content by excluding Retweets." />

          {![62, 63, 65, 69, 71, 73, 78, 67].includes(themeId) ? <CheckBox label="Text Decoration" id="textDecoration" checked={textDecorate} onChange={(e) => themeSetting({ textDecorate: e.target.checked })} tooltip="Enables big font double quotes for text posts." /> : ''}

          <CheckBox label="Protected" id="protected" checked={publicAccess} onChange={(e) => { themeSetting({ publicAccess: e.target.checked }); themeSettingStatus(true) }} tooltip="Extend privacy for your social wall by enabling Protected layer." />

          {/* { // embed autoPlay option } */}
          <CheckBox label="Embed Autoplay" id="autoPlay" checked={autoPlay} onChange={(e) => { themecardStyle({ autoPlay: e.target.checked }); themeSettingStatus(true) }} tooltip="Play short clips instead of static images for embedding content." />

          {'next-update' && [""].includes(themeId) && <><div className="col-12" style={{ display: animateBackground ? '' : 'none' }}>
            <div className="form-group">
              <label className="control-label" style={{ width: "100%" }}> Transitions Color
                <div className="select-box pt-2">
                  {bgColorSelect && bgColorSelect.length > 0 ? <Select options={bgColorSelect} value={bgColorSelect[bgColorSelect.findIndex(i => i.value == transitionStatus)]}
                    onChange={e => themeSetting({ transitionStatus: e.value })} /> : null}
                </div>
              </label>
            </div>
          </div>
            <div className="col-12 banner-bg-color" style={{ display: (animateBackground & transitionStatus == 1) ? '' : 'none' }}>
              <div className="form-group"  >
                <label>Transition Color</label>
                <div className="minicolors minicolors-theme-bootstrap minicolors-position-bottom minicolors-position-left"> <input className="form-control minicolors-input" maxlength="10" type="text" id="bgColorTransition" value={bgColor} /> </div>
              </div>
            </div></>}

          <div className="row">
            {[71].includes(themeId) ?
              <div className="col-sm-12">
                <div className="form-group">
                  <label className="control-label" htmlFor="No of Rows">
                    No.of Rows
                  </label>
                  <Select options={rowSelect} classNamePrefix="selectpicker" defaultValue={rowSelect[multiRow - 1]} onChange={e => themecardStyle({ multiRow: e.value })} />
                </div>
              </div> : null}


            {[68].includes(themeId) ?

              <div className="col-12">
                <div className="form-group">
                  <label className="control-
                
                " htmlFor="ThemeRulenumberOfCoumn">
                    Columns
                  </label>
                  <Select options={columnSelectFocus} value={columnSelectFocus[columnSelectFocus.findIndex(i => i.value == numberOfCoumn)]}
                    onChange={e => themecardStyle({ numberOfCoumn: e.value }, 1)} />
                </div>
              </div>
              : null}


            {[64, 69, 67, 70, 71, 72, 73].includes(themeId) && !(['182120'].includes(localStorage.getItem('ownerId')) && [67].includes(themeId)) ?

              <div className="col-12">
                <div className="form-group">
                  <label className="control-label" htmlFor="ThemeRulenumberOfCoumn">
                    Columns
                  </label>

                  {[67].includes(themeId) ?

                    <Select options={moblieColumnSelect} value={moblieColumnSelect[moblieColumnSelect.findIndex(i => i.value == numberOfCoumn)]}
                      onChange={e => themecardStyle({ numberOfCoumn: e.value })} />
                    :
                    [70, 71, 72, 73].includes(themeId) ?
                      <Select options={carouselColumnSelect} value={carouselColumnSelect[carouselColumnSelect.findIndex(i => i.value == numberOfCoumn)]}
                        onChange={e => themecardStyle({ numberOfCoumn: e.value }, 1)} />
                      :
                      <Select options={columnSelect} value={columnSelect[columnSelect.findIndex(i => i.value == numberOfCoumn)]}
                        onChange={e => themecardStyle({ numberOfCoumn: e.value }, 1)} />
                  }

                </div>
              </div>
              : null}
          </div>

          <div className="col-12">
            <div className="form-group">
              <label htmlFor="wallnumberOfPosts" className="me-2">
                Number of Posts of Display
              </label>

              <OverlayTrigger placement="top" overlay={<Tooltip>Maximum no. of posts to be displayed on live wall.</Tooltip>}>
                <span>
                  <FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'text-gray-500 fs-6'} />
                </span>
              </OverlayTrigger>


              <div className="totlPostDsply">
                <input type="number" className="form-control" autoComplete="off" value={numberOfPosts > maxPostsLimit ? maxPostsLimit : numberOfPosts}
                  name="data[ThemeRule][numberOfPosts]" min="1" max={maxPostsLimit} onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1'); themeSetting({ numberOfPosts: Number(e.target.value) > maxPostsLimit ? maxPostsLimit : e.target.value }) }} onChange={(e) => { themeSetting({ numberOfPosts: Number(e.target.value) > maxPostsLimit ? maxPostsLimit : e.target.value }); themeSettingStatus(true) }}
                />
              </div>
            </div>
          </div>


          {![63, 65, 67, 69, 71, 73].includes(themeId) ?
            <div className="form-group">
              <label className="control-label" htmlFor="trimContent">No. of Line Trim</label>
              <Select inputId="trimContent" options={trimLineSelect} classNamePrefix="selectpicker" value={trimLineSelect.find(i => i.value == trimcontent) || trimLineSelect[0]} onChange={e => themecardStyle({ trimcontent: e.value })} />
            </div> : null}


          <div className="col-sm-12">
            <div className="form-group">
              <label className="control-label" htmlFor="No of Rows">
                Sort Posts By
                <OverlayTrigger placement="top" overlay={<Tooltip> Showcase your most popular content at the very top.</Tooltip>}>
                  <span className="ms-2">
                    <FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'text-gray-500 fs-6'} />
                  </span>
                </OverlayTrigger>

              </label>
              <Select options={aiRecommendedOption} classNamePrefix="selectpicker" defaultValue={aiRecommendedOption[randomizePost]}
                onChange={e => { themeSetting({ randomizePost: e.value }); themeSettingStatus(true); setShufflePost(true) }} isSearchable={false} />
            </div>
          </div>

          {[62, 63, 65, 78, 66].includes(themeId) ? <div className="col-12">
            <div className="form-group">
              <label className="control-label" htmlFor="No of Rows">
                Scroll Speed
              </label>
              <Select menuPlacement="top" options={scrollSpeed} value={scrollSpeed[scrollSpeed.findIndex(i => i.value == scrollDelay)]}
                onChange={e => themeSetting({ scrollDelay: e.value })} />
            </div>
          </div> : null}

          <div className="d-flex align-items-center form-group">
            <div className="col-9">
              <label
                ref={hideOldPostsLabelRef}
                className={`control-label me-2 mb-0${highlightHideOldPosts ? ' highlight-label' : ''}`}
                style={{ backgroundColor: highlightHideOldPosts ? 'yellow' : '' }}
              >
                Hide Old Posts
              </label>
              <OverlayTrigger placement="top" overlay={<Tooltip>Hides old posts on your live wall.</Tooltip>}>
                <span>
                  <FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'text-gray-500 fs-6'} />
                </span>
              </OverlayTrigger>
            </div>
            <div className="col-3">
              <div className="toggleOnBut">
                <span className="switch float-end">
                  <label className="checkbox" htmlFor="wallhidePosts">
                    <input type="checkbox" name="data[Personalization][hidePosts]" id="wallhidePosts" className="onoffswitch-checkbox updateStatus" data-on-color="#009385" data-off-color="#989898" defaultValue={showHideOlderPost} checked={showHideOlderPost} onChange={(e) => {
                      setHideOld(Number(e.target.checked))
                      themeSettingStatus(true)
                      if (!Number(e.target.checked)) return themeSetting({ showHideOlderPost: 0 })
                      themeSetting({ showHideOlderPost: 1 })
                    }}
                    />
                    <span></span>
                  </label>
                </span>{" "}
              </div>
            </div>
          </div>


          <div className="col-12" id="wallhideOlderPosts" style={{ display: hideOld ? '' : "none" }}>
            <div className="form-group">
              {Number(showHideOlderPost) ? <Select menuPlacement="top" options={customSlelect} defaultValue={customSlelect[showHideOlderPost == 30 ? 7 : showHideOlderPost == 8 ? 8 : showHideOlderPost - 1]}
                onChange={e => themeSetting({ showHideOlderPost: e.value })} /> : null}
            </div>
          </div>


          <div className="col-12 hidepostDate" id="wallhideOldPosts" style={{ display: showHideOlderPost == 8 && hideOld ? "" : 'none' }}>
            <div className="form-group">
              <div className="input-group date dateTimePicker fgroupEndAtHide">
                <DateTimeField language={'en'} dateTime={date == 0 ? '' : moment.unix(date).utc().format('MM/DD/YYYY HH:mm')} inputFormat={'DD/MM/YYYY HH:mm'} onChange={(e) => handleChange(e)} viewMode={'date'}
                  className="form-control" startOfWeek={'week'} ref={myRefname} defaultText="Select date & time" />
                <div onClick={(e) => { myRefname.current.onClick() }} className="input-group-append">
                  <span className="input-group-text">
                    <i className="fa fa-calendar-days"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>


          {[62, 63, 65, 78].includes(themeId) ?
            <div className="col-12 card-width-style ">
              <div className="form-group pe-0">
                <label className="d-flex align-items-center justify-content-between" htmlFor="wallminimumPostWidth">
                  Minimum Post Width <span><span className="datawallminimumPostWidth">{postWidth}</span>px<span>
                  </span></span></label>
                <Slider onChange={(event) => { themeSetting({ minimumPostWidth: parseInt(event) }); setPostWidth(parseInt(event)) }}
                  trackStyle={{ background: "var(--brand-gradient)" }}
                  value={postWidth}
                  min={150}
                  max={500}
                />

                <input type="hidden" name="data[Personalization][minimumPostWidth]" value="300" className="form-control" id="wallminimumPostWidth" />					</div>
            </div> : ''}

          {'next-update' && [""].includes(themeId) && <div className="d-flex align-items-center form-group">
            <div className="col-9">
              <label className="control-label me-2 mb-0" htmlFor="blur">Blur Background </label>
              <OverlayTrigger placement="top" overlay={<Tooltip>This option will show blur background behind image.</Tooltip>}>
                <span>
                  <FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'text-gray-500 fs-6'} />
                </span>
              </OverlayTrigger>
            </div>
            <div className="col-3">
              <div className="toggleOnBut">
                <span className="switch float-end">
                  <label htmlFor="blur">
                    <input type="checkbox" name="data[Personalization][autoUpdate]" id="blur" className="onoffswitch-checkbox updateStatus" data-on-color="#009385" data-off-color="#989898" defaultValue={blurBackground} checked={blurBackground} onChange={(e) => themeSetting({ blurBackground: e.target.checked })}
                    />
                    <span></span>
                  </label>
                </span>{" "}
              </div>
            </div>

          </div>}

          {'next-update' && [""].includes(themeId) &&
            <div className="col-12" style={{ display: blurBackground == 0 ? '' : 'none' }}>
              <div className="form-group">
                <label className="control-label mb-2">Blur color</label>
                <div className="minicolors minicolors-theme-bootstrap minicolors-position-bottom minicolors-position-left"> <input className="form-control minicolors-input" maxlength="10" type="text" id="blurColor" value={blur} /> </div>
              </div>
            </div>}

          {postFeatured && ![74, 76, 77].includes(themeId) ? <div className="col-sm-12 card-width-style ">
            <div className="form-group pe-3">
              <label className="d-flex align-items-center justify-content-between" htmlFor="wallminimumPostWidth">
                Pop-up Duration
                <span><span className="datawallminimumPostWidth">{timeForPopup}</span>s<span>
                </span></span></label>
              <Slider onChange={(event) => themeSetting({ timeForPopup: event })}
                trackStyle={{ background: "var(--brand-gradient)" }}
                value={timeForPopup}
                min={10}
                max={60}
              />
              <input type="hidden" name="data[minimumPostWidth]" value="300" className="form-control" id="wallminimumPostWidth" />
            </div>
          </div> : null}

          {![62, 63, 64, 65, 66, 69, 71, 78].includes(themeId) ? <div className="col-sm-12 card-width-style ">
            <div className="form-group pe-3">
              <label className="d-flex align-items-center justify-content-between" htmlFor="wallminimumPostWidth">
                Time per slide ( {slideDelay} seconds)</label>
              <Slider onChange={(event) => themeSetting({ slideDelay: event })}
                trackStyle={{ background: "var(--brand-gradient)" }}
                value={slideDelay}
                min={1}
                max={120}
              />
              <input type="hidden" name="data[minimumPostWidth]" value="300" className="form-control" id="wallminimumPostWidth" />
            </div>
          </div> : null}

        </div>

      </div>
      <div className="form-actions px-3 mt-3">
        <div className="card-toolbar d-flex align-items-center justify-content-end w-100">
          <Button variant="secondary" onClick={() => applyChanges(0)} className="me-2 w-50">Back</Button>
          <Button variant="dark" type="submit" disabled={spinner} onClick={() => applyChanges(1)} className={`me-2 w-50 ${spinner ? `spinner spinner-white spinner-right disabled` : ''}`}>Save</Button>
          <OverlayTrigger placement="right" overlay={<Tooltip>Help</Tooltip>}>
            <a href="https://vimeo.com/545385626/85e2b06601" data-lity>
              <FontAwesomeIcon type={'regular'} icon={'circle-question'} iconClass={'text-gray-500'} />
            </a>
          </OverlayTrigger>
        </div>
      </div>
    </div >
  );
};

export default ThemeSetting;

const CheckBox = ({ label, id, checked, onChange, tooltip }) => {
  return (
    <div className="d-flex align-items-center form-group me-2 mb-2">
      <div className="col-9">
        <label className="control-label me-2" htmlFor={id}>{label}</label>
        <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
          <span>
            <FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'text-gray-500 fs-6'} />
          </span>
        </OverlayTrigger>
      </div>
      <div className="col-3 mt-2">
        <div className="toggleOnBut">
          <span className="switch float-end">
            <label htmlFor={id}>
              <input type="checkbox" id={id} className="onoffswitch-checkbox" data-on-color="#009385" data-off-color="#989898" checked={checked} onChange={onChange} />
              <span></span>
            </label>
          </span>
        </div>
      </div>
    </div>
  )
}